import type { MCPaperformParams } from './MCPaperformParams';

/**
 * Insert a modal dialog containing the specified Paperform form.
 * The form is preloaded so that it appears instantly when
 * openPaperform(formId) is called to display it.
 *
 * @param formId Paperform id
 * @param params Form parameters
 * @param popupTitle Title for the popup window
 */
export function insertPaperformPopup(
  formId: string,
  params: MCPaperformParams = {},
  popupTitle?: string,
) {
  const modal = document.createElement('div');
  modal.className = 'modal';
  modal.id = `form-modal-${formId}`;
  modal.style.right = '0px';

  const modalDialog = document.createElement('div');
  modalDialog.className = 'modal-dialog';
  modalDialog.style.maxWidth = '800px';
  modal.appendChild(modalDialog);

  const modalContent = document.createElement('div');
  modalContent.className = 'modal-content';
  modalDialog.appendChild(modalContent);

  const closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.className = 'close';
  closeButton.dataset.dismiss = 'modal';
  closeButton.setAttribute('aria-label', 'Close');

  const closeButtonContent = document.createElement('span');
  closeButtonContent.setAttribute('aria-hidden', 'true');
  closeButtonContent.innerHTML = '&times;';
  closeButton.appendChild(closeButtonContent);

  if (popupTitle) {
    const modalHeader = document.createElement('div');
    modalHeader.className = 'modal-header';

    const modalTitle = document.createElement('h5');
    modalTitle.className = 'modal-title';
    modalTitle.innerText = popupTitle;
    modalDialog.appendChild(modalHeader);
    modalHeader.appendChild(closeButton);
    modalContent.appendChild(modalHeader);
  }

  const modalBody = document.createElement('div');
  modalBody.className = 'modal-body';
  if (!popupTitle) {
    closeButton.style.float = 'none';
    closeButton.style.marginLeft = 'auto';
    closeButton.style.marginRight = '0px';
    closeButton.style.display = 'block';
    modalBody.appendChild(closeButton);
  }
  modalContent.appendChild(modalBody);

  window.insertPaperform(modalBody, formId, { ...params, popup: undefined });

  document.body.appendChild(modal);
}
